import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab10',
  templateUrl: './awsop-lab10.component.html',
  styleUrls: ['./awsop-lab10.component.css']
})
export class AwsopLab10Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab10/awsop-lab10.component.ts